import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { arrayIsSet } from '../../../providers/service/global-variables.service';
import { ActionsButtons } from 'src/app/providers/service/open-dialog.service';


export interface MultipleActionsData {
    title?: string;
    titleTraductionKey?: string;
    subtitle?: string;
    subtitleTraductionKey?: string;
    messages?: {
        title?: string,
        titleTraductionKey?: string,
        cssClassTitle?: string,
        subTitles?: { title?: string, titleTraductionKey?: string, subtitle?: string, subtitleTraductionKey?: string }[]
    }[]
    actions: ActionsButtons[];
    showCancelButton?: boolean;
    cancelButtonLabel?: string;
    confirmButtonLabel?: string;
    multiple: boolean
}

@Component({
    selector: 'app-multiple-actions',
    templateUrl: './multiple-actions.component.html',
    styleUrls: ['./multiple-actions.component.scss'],
    standalone: false
})
export class MultipleActionsComponent implements OnInit {

    public selectedActions: ActionsButtons[] = [];

    constructor(
        public dialogRef: MatDialogRef<MultipleActionsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MultipleActionsData
    ) {
        // Set default values
        if (this.data.multiple === undefined) {
            this.data.multiple = false;
        }
        if (this.data.showCancelButton === undefined) {
            this.data.showCancelButton = true;
        }
        if (!this.data.cancelButtonLabel) {
            this.data.cancelButtonLabel = 'cancel';
        }
        if (!this.data.confirmButtonLabel) {
            this.data.confirmButtonLabel = 'confirm';
        }
    }

    ngOnInit(): void {
        // Initialize component
    }

    trackByActionId(index: number, action: ActionsButtons): string {
        return action.action;
    }

    isActionSelected(action: ActionsButtons): boolean {
        return this.selectedActions.findIndex(selected => selected.action === action.action) >= 0;
    }

    isActionDisabled(action: ActionsButtons): boolean {
        return action.disabled === true;
    }

    clickAction(action: ActionsButtons): void {
        if (this.isActionDisabled(action)) {
            return;
        }
        if (this.data.multiple == false) {
            this.dialogRef.close([action])
        }
        const index = this.selectedActions.findIndex(selected => selected.action === action.action);

        if (index >= 0) {
            // Action is already selected, remove it
            this.selectedActions.splice(index, 1);
        } else {
            this.selectedActions.push(action);
        }

    }

    getActionButtonClass(action: ActionsButtons): string {
        let classes = ['action-button'];

        if (this.isActionDisabled(action)) {
            classes.push('disabled');
        } else if (this.isActionSelected(action)) {
            classes.push('selected');
        }

        if (action.color) {
            classes.push(`mat-${action.color}`);
        }

        return classes.join(' ');
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm(): void {
        this.dialogRef.close({
            selectedActions: this.selectedActions,
            confirmed: true
        });
    }

    get isConfirmDisabled(): boolean {
        return !arrayIsSet(this.selectedActions);
    }

    get hasActions(): boolean {
        return arrayIsSet(this.data.actions);
    }
}